import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { packageButtonStyles } from "../../styles/package-button";
import { documents } from "../../svg";

@customElement("umb-market-package-toast")
export class UmbMarketPackageToast extends LitElement {
  @property()
  type!: "nuget" | "dotnet" | "npm";

  @property()
  action?: string;

  @property()
  title!: string;

  #command?: string;

  connectedCallback() {
    super.connectedCallback();
    this.#command =
      this.type === "nuget" ? "Install-Package" : `${this.type} ${this.action}`;
  }

  #copyPackageCommand() {
    navigator.clipboard.writeText(`${this.#command} ${this.title}`).then(() => {
      const icon = this.renderRoot.querySelector(".btn-icon")! as HTMLElement;
      icon.classList.add("copied");

      setTimeout(() => {
        icon.classList.remove("copied");
      }, 1000);
    });

    this.dispatchEvent(
      new CustomEvent("install-button-click", {
        bubbles: true,
        composed: true,
        detail: {
          command: this.#command,
        },
      })
    );
  }

  render() {
    return html`<umb-market-button @click=${this.#copyPackageCommand}>
      <div class="btn-text">
        <small class="btn-subtitle">${this.#command}</small>
        <span class="btn-title">${this.title}</span>
      </div>
      <span class="btn-icon" slot="append">
        <span>Copied to clipboard</span>${documents}</span
      >
    </umb-market-button>`;
  }

  static styles = [packageButtonStyles];
}
